import { useState } from "react";

interface Prop {
  optInWording?: string;
  setShowModal: () => void;
  subName?: string;
  callUpdateApi?: (subName: string) => void;
  showUnsubscribe: boolean;
  callUnsubscribe?: () => void;
}

export default ({ optInWording, setShowModal, subName, callUpdateApi, showUnsubscribe, callUnsubscribe }: Prop) => {
  if (!showUnsubscribe && callUpdateApi === undefined) return <></>
  if (showUnsubscribe && callUnsubscribe === undefined) return <></>

  const [isSubscribeDisabled, setIsSubscribeDisabled] = useState(true);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setShowModal();
  }

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    callUpdateApi!(subName!);
    setShowModal();
  }

  const onSubmitUnsubscribeAll = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    callUnsubscribe!();
    setShowModal();
  }

  const UnsubAllModalTop = () => {
    return (
      <>
        <p>
          <strong>
            Are you sure you want to stop receiving ALL e-mail communications from RAPS? If you change your mind, you can resubscribe to our communications from this page at any point in time. We are
            sorry to see you go!
          </strong>
        </p>
      </>
    );
  };

  const SubModalBottom = () => {
    return (
      <>
        <button id="btnSubscribe" type="submit" className="btn btn-success" disabled={isSubscribeDisabled}>
          Subscribe
        </button>
      </>
    );
  };

  const UnSubAllModalBottom = () => {
    return (
      <>
        <button type="submit" className="btn btn-danger" id="btnUnsubscribeAll">
          Unsubscribe
        </button>
      </>
    );
  };

  return (
    <div className="jquery-modal blocker current" onClick={setShowModal}>
      <div id="subwindow" className="modal react-modal" style={{ display: "inline-block" }} onClick={(e) => e.stopPropagation()}>
        <form className="form-horizontal" onSubmit={!showUnsubscribe ? onSubmit : onSubmitUnsubscribeAll}>
          <div className="form-group row">
            <div className="col-sm-offset-2 col-sm-8">
              <div className="checkbox">
                {!showUnsubscribe ? (
                  <label>
                    <input
                      id="cbOptIn"
                      type="checkbox"
                      onChange={() => {
                        setIsSubscribeDisabled(!isSubscribeDisabled);
                      }}
                      required
                    />
                    <div dangerouslySetInnerHTML={{ __html: optInWording! }}></div>
                  </label>
                ) : (
                  <UnsubAllModalTop />
                )}
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="col-sm-offset-4 col-sm-6">
              <a type="button" className="btn btn-primary" onClick={handleClick}>
                Cancel
              </a>
              <a rel="modal:close">{!showUnsubscribe ? <SubModalBottom /> : <UnSubAllModalBottom />}</a>
            </div>
          </div>
        </form>
        <a href="#close-modal" className="close-modal" onClick={handleClick}>
          Close
        </a>
      </div>
      <style>
        {`
          .blocker {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: auto;
            z-index: 1;
            padding: 20px;
            box-sizing: border-box;
            background-color: #000;
            background-color: rgba(0,0,0,0.75);
            text-align: center;
          }
          .blocker:before {
            content: "";
            display: inline-block;
            height: 100%;
            vertical-align: middle;
            margin-right: -0.05em;
          }
          .modal {
            display: none;
            vertical-align: middle;
            position: relative;
            z-index: 2;
            max-width: 500px;
            box-sizing: border-box;
            width: 90%;
            background: #fff;
            padding: 15px 30px;
            -webkit-border-radius: 8px;
            -moz-border-radius: 8px;
            -o-border-radius: 8px;
            -ms-border-radius: 8px;
            border-radius: 8px;
            -webkit-box-shadow: 0 0 10px #000;
            -moz-box-shadow: 0 0 10px #000;
            -o-box-shadow: 0 0 10px #000;
            -ms-box-shadow: 0 0 10px #000;
            box-shadow: 0 0 10px #000;
            text-align: left;
          }
          .modal a.close-modal {
            position: absolute;
            top: -12.5px;
            right: -12.5px;
            display: block;
            width: 30px;
            height: 30px;
            text-indent: -9999px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAA3hJREFUaAXlm8+K00Acx7MiCIJH/yw+gA9g25O49SL4AO3Bp1jw5NvktC+wF88qevK4BU97EmzxUBCEolK/n5gp3W6TTJPfpNPNF37MNsl85/vN/DaTmU6PknC4K+pniqeKJ3k8UnkvDxXJzzy+q/yaxxeVHxW/FNHjgRSeKt4rFoplzaAuHHDBGR2eS9G54reirsmienDCTRt7xwsp+KAoEmt9nLaGitZxrBbPFNaGfPloGw2t4JVamSt8xYW6Dg1oCYo3Yv+rCGViV160oMkcd8SYKnYV1Nb1aEOjCe6L5ZOiLfF120EjWhuBu3YIZt1NQmujnk5F4MgOpURzLfAwOBSTmzp3fpDxuI/pabxpqOoz2r2HLAb0GMbZKlNV5/Hg9XJypguryA7lPF5KMdTZQzHjqxNPhWhzIuAruOl1eNqKEx1tSh5rfbxdw7mOxCq4qS68ZTjKS1YVvilu559vWvFHhh4rZrdyZ69Vmpgdj8fJbDZLJpNJ0uv1cnr/gjrUhQMuI+ANjyuwftQ0bbL6Erp0mM/ny8Fg4M3LtdRxgMtKl3jwmIHVxYXChFy94/Rmpa/pTbNUhstKV+4Rr8lLQ9KlUvJKLyG8yvQ2s9SBy1Jb7jV5a0yapfF6apaZLjLLcWtd4sNrmJUMHyM+1xibTjH82Zh01TNlhsrOhdKTe00uAzZQmN6+KW+sDa/JD2PSVQ873m29yf+1Q9VDzfEYlHi1G5LKBBWZbtEsHbFwb1oYDwr1ZiF/2bnCSg1OBE/pfr9/bWx26UxJL3ONPISOLKUvQza0LZUxSKyjpdTGa/vDEr25rddbMM0Q3O6Lx3rqFvU+x6UrRKQY7tyrZecmD9FODy8uLizTmilwNj0kraNcAJhOp5aGVwsAGD5VmJBrWWbJSgWT9zrzWepQF47RaGSiKfeGx6Szi3gzmX/HHbihwBser4B9UJYpFBNX4R6vTn3VQnez0SymnrHQMsRYGTr1dSk34ljRqS/EMd2pLQ8YBp3a1PLfcqCpo8gtHkZFHKkTX6fs3MY0blKnth66rKCnU0VRGu37ONrQaA4eZDFtWAu2fXj9zjFkxTBOo8F7t926gTp/83Kyzzcy2kZD6xiqxTYnHLRFm3vHiRSwNSjkz3hoIzo8lCKWUlg/YtGs7tObunDAZfpDLbfEI15zsEIY3U/x/gHHc/G1zltnAgAAAABJRU5ErkJggg==);
          }
        `}
      </style>
    </div>
  );
};
